import { render, staticRenderFns } from "./DepartmentIncome.vue?vue&type=template&id=836badae&scoped=true&"
import script from "./DepartmentIncome.vue?vue&type=script&lang=js&"
export * from "./DepartmentIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836badae",
  null
  
)

export default component.exports